import { createFileRoute, redirect } from "@tanstack/react-router";
import { DEFAULT_APPROVAL_SEARCH } from "@/lib/approval-search";
import { requireModule } from "@/lib/module-access";

/** Legacy route retained for saved links after approvals moved into AI Operations. */
export const Route = createFileRoute("/_authed/approvals")({
  beforeLoad: () => {
    requireModule("approvals");
    throw redirect({ to: "/ai-operations", search: DEFAULT_APPROVAL_SEARCH });
  },
});
